import { ClientConfig } from './types';

let cachedConfig: ClientConfig | null = null;

/**
 * Fetch the configuration for the browser client and cache it
 */
const getClientConfig = async (): Promise<ClientConfig> => {
  if (cachedConfig) {
    return cachedConfig;
  }

  const response = await fetch('/api/config/client');
  if (response.status !== 200) {
    throw new Error('Client config fetch failed');
  }

  cachedConfig = (await response.json()) as ClientConfig;
  return cachedConfig;
};

export default getClientConfig;
